class Uploader {

    constructor(elementSelector, params = {}) {

        if ($(elementSelector).length == 0) {
            return;
        }

        this.elementSelector = elementSelector;
        this.element = $(elementSelector);
        this.elementDroppable = this.element.find('.block-upload');
        this.container = this.element.find('.images');
        this.imageBlock = $(this.element.find('.block-image-template').html());

        
        this.inputSelector = '#images';

        this.images = [];
        this.itemId = typeof this.element.data('item-id') != 'undefined'
            ? this.element.data('item-id')
            : null;
        this.module = typeof this.element.data('module') != 'undefined'
            ? this.element.data('module')
            : null;
        this.tableName = typeof this.element.data('table-name') != 'undefined' 
            ? this.element.data('table-name')
            : null;

        this.amountMaximal = typeof this.element.data('amount-maximal') != 'undefined' 
            ? this.element.data('amount-maximal')
            : null;

        this.editor = typeof this.element.data('editor') != 'undefined' 
            ? (this.element.data('editor') == 1
                ? true
                : false)
            : false;

        if (this.editor) {

            this.editorOptions = {
                'aspectratio': 'freeform',
                'aspectratio_maintain_default': true
            }

            if (typeof this.element.data('editor-aspectratio') != 'undefined' ) {
                this.editorOptions.aspectratio = this.element.data('editor-aspectratio');
            }

            if (typeof this.element.data('editor-aspectratio-maintain-default') != 'undefined' ) {
                this.editorOptions.aspectratio_maintain_default = this.element.data('editor-aspectratio-maintain-default');
            }

            if (this.editorOptions.aspectratio != 'freeform') {
                this.editorOptions.aspectratio = this.editorOptions.aspectratio.split('x');
                this.editorOptions.aspectratio[0] = parseInt(this.editorOptions.aspectratio[0]);
                this.editorOptions.aspectratio[1] = parseInt(this.editorOptions.aspectratio[1]);
            }
        }

        this.type = 'multi';
        if (typeof this.element.data('type') != 'undefined') {
            this.type = this.element.data('type');
        }

        if (this.type == 'single') {

            this.preview = {
                'width': 300,
                'height': 300
            };

            if (typeof this.element.data('preview-width') != 'undefined') {
                this.preview.width = this.element.data('preview-width');
            }

            if (typeof this.element.data('preview-height') != 'undefined') {
                this.preview.height = this.element.data('preview-height');
            }
        }

        this.getImageParams();
        
        this.processingImages = 0;
        
        this.onChange = function(){};
        if (typeof params.onChange != 'undefined') {
            this.onChange = params.onChange;
        }

        this.preventDefault();
        
        this.load();

        this.imageEvents();
        this.uploadEvent();
        this.droppableEvents();
        if (this.type != 'single') {
            this.sortableEvents();
        }

        this.setData();
    }

    load() {

        var self = this;

        var images = [];
        if (this.element.find(this.inputSelector).val() != '') {
            images = [];
            $.each(JSON.parse(this.element.find(this.inputSelector).val()), function(i, value) {
                images.push(value);
            });
        }

        function loadImage(i) {

            if (i == images.length) {
                return;
            }

            let img = new Image();

            img.onload = function () {
                if (typeof images[i].editor_bbox_freeform == 'undefined') {
                    images[i].editor_bbox_freeform = self.editorOptions.aspectratio_maintain_default;
                }

                self.addImage(images[i]);
                loadImage(++i);
            }

            img.src = images[i].image_src_uploader;
        }

        loadImage(0);
    }

    sortableEvents() {
        
        var self = this;

        this.container.sortable({
            cancel: '.block-container-upload',
            tolerance: "pointer",
            containment: '.content',
            stop: function() {
                
                var images = [];

                self.container.find('.block-image').each(function() {

                    var src = $(this).find('img').attr('src'), 
                        i = 0, 
                        l = self.images.length,
                        image;

                    while (i < l) {
                        
                        image = typeof self.images[i].data == 'string'
                            ? self.images[i].data
                            : self.images[i].data.image_src_uploader;

                        if (image == src) {
                            images.push(self.images[i]);
                        }
                        ++i;
                    }   
                });

                self.images = images;
                self.setData();
            }
        });
    }

    droppableEvents() {

        var self = this;

        this.elementDroppable
            .on('drop', function(e) {

                self.upload(e.originalEvent.dataTransfer.files);
            })
            .on("dragenter dragover", function(e) {
                $(this).addClass('dragover');
            })
            .on("dragleave dragend drop", function(e) {
                $(this).removeClass('dragover');
            });
    }

    imageEvents() {

        var self = this;

        $(document).on('click', this.elementSelector+' .block-image .option-delete', function() {
            self.removeImage($(this).closest('.block-image').find('img').attr('src'));
        });
        
        $(document).on('click', this.elementSelector+' .block-image .option-text', function() {


            let image = $(this).closest('.block-image').find('img'),
                imageId = self.getImageIdBySrc(image.attr('src')),
                content;

                console.log(imageId);
           
            if (imageId === false) {
                return;
            }

            content = self.element.find('.option-text-template').html().replace(
                /(href|id)(=")(\#*)(modal-tab-lang-[a-z]{2})"/ig, 
                `$1$2$3$4-open"`
            );

            content = $(content, image);

            content.find('#image_id')
                .val(imageId.toString())
                .attr('value', imageId.toString());

            if (content.find('#is_hover').length > 0) {
                content.find('#is_hover')
                    .attr('id', 'is_hover_' + imageId.toString());

                content.find('#is_hover_' + imageId.toString())
                    .siblings('label')
                    .attr('for', 'is_hover_' + imageId.toString());
            }

            if (content.find('#is_variant_image').length > 0) {
                content.find('#is_variant_image')
                    .attr('id', 'is_variant_image_' + imageId.toString());

                content.find('#is_variant_image_' + imageId.toString())
                    .siblings('label')
                    .attr('for', 'is_variant_image_' + imageId.toString());
            }
            
            let params = {
                "title": 'Information',
                "content": self.loadDataInInputs(content),
                "class": 'modal-xl',
                "buttons": [
                    '<button type="button" class="btn btn-danger btn-text-save" data-uploader-module="'+self.elementSelector+'">Save</button>'
                ]
            };

            if (self.editor) {
                params.callBack = function() {
                    self.setEditor(image);
                }
            }

            new Modal(params);
        });      

        $(document).on('click', this.elementSelector+' .block-image .option-star', function() {

            let imageId = self.getImageIdBySrc($(this).closest('.block-image').find('img').attr('src')),
                prefix = $(this).attr('data-prefix') == 'far'
                    ? 'fas'
                    : 'far',
                l = self.images.length,
                i;

            if (imageId === false) {
                return;
            }

            //set all block images star off
            $(self.elementSelector+' .option-star').each(function() {
                $(this).attr('data-prefix', 'far');
            });

            //set all images data off
            for (i = 0; i < l; ++i) {
                self.images[i].data.star = false;
            }

            //set current image data on
            self.images[imageId].data.star = prefix == 'fas'
                ? true
                : false;

            console.log(self.images)

            //set current image icon on
            $(this).closest('.block-image').find('.option-star').attr('data-prefix', prefix);

            self.setData();
        });

        $(document).on('click', this.elementSelector+' .block-image .option-aspectratio', function() {

            let imageId = self.getImageIdBySrc($(this).closest('.block-image').find('img').attr('src')),
                l = self.images.length,
                i;

            if (imageId === false) {
                return;
            }

            delete self.images[imageId].data.editor_bbox;

            $(this).attr('data-prefix', $(this).attr('data-prefix') == 'far'
                ? 'fas'
                : 'far');

            self.images[imageId].data.editor_bbox_freeform = $(this).attr('data-prefix') == 'fas'
                ? false
                : true;

            self.setEditorPreview(imageId);

            self.setData();
        });

        $(document).on('click', this.elementSelector+' .block-image .option-download', function() {

            let imageId = self.getImageIdBySrc($(this).closest('.block-image').find('img').attr('src')),
                location,
                elm;

            if (imageId === false) {
                return;
            }

            location = self.images[imageId].data.image_src_uploader;
            if (!(/\_new\.\D+/gm.exec(self.images[imageId].data.image_src_uploader))) {
                
                location = self.images[imageId].data.image_src_uploader.replace(
                    /\_(\D+)(\.\D+)/gm, 
                    `_origin$2`
                );
            }

            elm = $('<a class="download-image" href="'+location+'" download></a>');
            elm.get(0).click();
        });
        
        $(document).on('click', '.modal .btn-text-save', function() {
            
            if ($(this).data('uploader-module') != self.elementSelector) {
                return;
            }
     
            let content = $(this).closest('.modal').find('.modal-body'),
                imageId = content.find('#image_id').val(),
                l = self.images.length,
                i;
      
            content.find('input:not([type=hidden])').each(function() {
                self.images[imageId].data[$(this).attr('id')] = $(this).val();
            });

            content.find('textarea:not([type=hidden])').each(function() {
                self.images[imageId].data[$(this).attr('id')] = $(this).val();
            });

            content.find('input.image-status').each(function () {
                self.images[imageId].data[$(this).attr('name')] = $(this).is(':checked')
                    ? 1
                    : 0;
            });

            //set all images data off
            for (i = 0; i < l; ++i) {
                self.images[i].data.is_hover = 0;
                self.images[i].data.is_variant_image = 0;
            }

            self.images[imageId].data['is_hover'] = content.find('#is_hover_' + imageId).is(':checked') ? 1 : 0;
            self.images[imageId].data['is_variant_image'] = content.find('#is_variant_image_' + imageId).is(':checked') ? 1 : 0;

            self.setEditorPreview(imageId);
            
            self.setData();

            $('.modal').modal('hide');
        });
    }

    setEditor(image) {

        console.log('setEditor');

        let self = this,
            imageData = this.images[this.getImageIdBySrc(image.attr('src'))].data,
            content = $('.modal .modal-body'),
            params = {
                imageNaturalWidth: image.prop("naturalWidth"),
                imageNaturalHeight: image.prop("naturalHeight"),
                container: content.find('.image-editor')
            },
            dimensions,
            selectionUIParams = {
                containment: ".modal .image-editor .image",
                minHeight: 40,
                minWidth: 40,
                stop: function(e) {

                    let container = $('.modal .image-editor .image'),
                        percentWidth = container.width() / 100,
                        percentHeight = container.height() / 100,
                        selection = container.find('.selection'),
                        aspectRatio, 
                        width, 
                        height,
                        part;
                   
                    //recalibrate aspectratio (because jqueryUI screws it up at resizing sometimes)
                    if (selection.data('aspectratio') != 'freeform') {
                        aspectRatio = selection.data('aspectratio').split(',');
                        
                        part = aspectRatio[0] > aspectRatio[1]
                            ? selection.outerWidth() / aspectRatio[0]
                            : selection.outerHeight() / aspectRatio[1];

                        width = part * aspectRatio[0];
                        height = part * aspectRatio[1];

                        if (width > container.width() - 2) {
                            width = Math.round(part * aspectRatio[0]);
                        }
                        if (height > container.height() - 2) {
                            height = Math.round(part * aspectRatio[1]);
                        }

                        if (width > container.width()) {
                            width = container.width();
                        }
                        if (height > container.height()) {
                            height = container.height();
                        }

                        selection.css({
                            'width': width,
                            'height': height
                        });
                    }

                    self.images[$('.modal #image_id').val()].data.editor_bbox = {
                        top: selection.position().top / percentHeight,
                        left: selection.position().left / percentWidth,
                        width: selection.outerWidth() / percentWidth,
                        height: selection.outerHeight() / percentHeight
                    };

                    self.setEditorPreview($('.modal #image_id').val());

                    self.setData();
                }
            };
    
        if (typeof imageData.editor_bbox !== 'undefined') {
            params.bbox = imageData.editor_bbox;
        }
      
        dimensions = this.getImageDimensionsByContainer(params);

        content.find('.image-editor .image').css({
            'width': dimensions.content.width, 
            'height': dimensions.content.height,
            'background-image': 'url('+image.attr('src')+')'
        });

        if (this.editorOptions.aspectratio != 'freeform' && 
            !imageData.editor_bbox_freeform) {
            selectionUIParams.aspectRatio = this.editorOptions.aspectratio[0]+" / "+this.editorOptions.aspectratio[1];

            content.find('.image-editor .image .selection')
        }

        content.find('.image-editor .image .selection')
            .data('aspectratio', typeof selectionUIParams.aspectRatio != 'undefined'
                ? this.editorOptions.aspectratio.join(',')
                : 'freeform'
            )
            .css({
                'top': dimensions.selection.top,
                'left': dimensions.selection.left,
                'width': dimensions.selection.width,
                'height': dimensions.selection.height
            })
            .draggable(selectionUIParams)
            .resizable(selectionUIParams);
    }

    getImageDimensionsByContainer(params) {
        
        console.log('-------------------------------');
        console.log('getImageDimensionsByContainer');

        let content = {
                width: 100,
                height: 100
            },
            selection = {
                left: 0,
                top: 0,
                width: 100,
                height: 100
            },
            percent,
            part, 
            aspectPoint,
            aspectPointContainer;
 
        percent = params.container.width() > params.container.height()
            ? params.container.height() / 100
            : params.container.width() / 100;

        if (params.imageNaturalWidth > params.imageNaturalHeight) {
            content.height = params.imageNaturalHeight / (params.imageNaturalWidth / 100);
        } else {
            content.width = params.imageNaturalWidth / (params.imageNaturalHeight / 100);
        }

        content.width = content.width * percent; //Math.round() ???
        content.height = content.height * percent; //Math.round() ???


        console.log('aspectratio:'+this.editorOptions.aspectratio);

        if (this.editorOptions.aspectratio != 'freeform') {

            aspectPoint = this.editorOptions.aspectratio[0] > this.editorOptions.aspectratio[1]
                ? this.editorOptions.aspectratio[0] / this.editorOptions.aspectratio[1]
                : this.editorOptions.aspectratio[1] / this.editorOptions.aspectratio[0];

            aspectPointContainer = content.width > content.height 
                ? content.width / content.height
                : content.height / content.width;

            //selection landscape
            if (this.editorOptions.aspectratio[0] > this.editorOptions.aspectratio[1]) {

                console.log('selection: landscape');

                //content landscape
                if (content.width > content.height) {
                    console.log('content: landscape');

                    //selection landscape is higher then container landscape
                    if (aspectPoint > aspectPointContainer) {
                        console.log('aspect: selection > content');
                        part = content.width / this.editorOptions.aspectratio[0];
                    } else {
                        console.log('aspect: selection < content');
                        part =  content.height / this.editorOptions.aspectratio[1];
                    }

                } else {
                    //content Portriat
                    console.log('content: Portriat');
                    part = content.width / this.editorOptions.aspectratio[0];
                }

            }

            //selection Portriat
            if (this.editorOptions.aspectratio[0] < this.editorOptions.aspectratio[1]) {
                
                console.log('selection: Portriat');

                 //content Portriat
                 if (content.width < content.height) {
                    console.log('content: Portriat');

                    //selection portriat is giher tyhen container Portriat
                    if (aspectPoint > aspectPointContainer) {
                        console.log('aspect: selection > content');
                        part =  content.height / this.editorOptions.aspectratio[1];
                    } else {
                        console.log('aspect: selection < content');
                        part = content.width / this.editorOptions.aspectratio[0];
                    }
                 } else {

                    //content Landscape
                    console.log('content: Landscape (or square)');
                    console.log(content.height+"="+this.editorOptions.aspectratio[1]);
                    part = content.height / this.editorOptions.aspectratio[1];
                 }
            }

            //square
            if (this.editorOptions.aspectratio[0] == this.editorOptions.aspectratio[1]) {

                console.log('selection: square');
                part = content.width > content.height
                    ? content.height / this.editorOptions.aspectratio[0]
                    : content.width / this.editorOptions.aspectratio[1];
            }   
            
            selection.width = this.editorOptions.aspectratio[0] * part;
            selection.height = this.editorOptions.aspectratio[1] * part;

        }

        selection.left = (content.width - selection.width) / 2;
        selection.top = (content.height - selection.height) / 2;

        if (typeof params.bbox !== 'undefined') {
            selection.width = params.bbox.width * (content.width / 100); 
            selection.height = params.bbox.height * (content.height / 100); 
            selection.top = params.bbox.top * (content.height / 100); 
            selection.left = params.bbox.left * (content.width / 100); 
        }

        let percentWidth = content.width / 100;
        let percentHeight = content.height / 100;

        selection.percent = {
            top: selection.top / percentHeight,
            left: selection.left / percentWidth,
            width: selection.width / percentWidth,
            height: selection.height / percentHeight
        };

        console.log({
            part: part,
            percent: percent,
            selection: selection,
            content: content,
        });

        return {
            part: part,
            percent: percent,
            selection: selection,
            content: content,
        }
    }

    setEditorPreview(imageId) {
        
        console.log('setEditorPreview');

        let image = this.images[imageId],
            imgElement = image.element.find('img'),
            params = {
                imageNaturalWidth: imgElement.prop("naturalWidth"),
                imageNaturalHeight: imgElement.prop("naturalHeight"),
                container: image.element.find('.image-container .content')
            },
            dimensions,
            dimensionsContainer,
            backgroundWidth, backgroundHeight,
            imageWidthCorrection, imageHeightCorrection,
            backgroundLeft, backgroundTop;

        if (this.editorOptions.aspectratio != 'freeform' &&
            !image.data.editor_bbox_freeform) {
            params.imageNaturalWidth = this.editorOptions.aspectratio[0] * 1000;
            params.imageNaturalHeight = this.editorOptions.aspectratio[1] * 1000;
        } else {

            if (typeof image.data.editor_bbox != 'undefined') {
                params.imageNaturalWidth = (image.data.editor_bbox.width * (params.imageNaturalWidth / 100)) * 100;
                params.imageNaturalHeight = (image.data.editor_bbox.height * (params.imageNaturalHeight / 100)) * 100;
            }

            if (typeof image.data.editor_bbox == 'undefined') {
                image.data.editor_bbox = this.images[imageId].data.editor_bbox = {
                    left: 0,
                    top: 0,
                    width: 100,
                    height: 100
                };
            }
        }

        dimensionsContainer = this.getImageDimensionsByContainer(params);
        
        params = {
            imageNaturalWidth: imgElement.prop("naturalWidth"),
            imageNaturalHeight: imgElement.prop("naturalHeight"),
            container: image.element.find('.image-container .content')
        };

        if (params.imageNaturalWidth == 0 ||
            params.imageNaturalHeight == 0) {

            params.imageNaturalWidth = image.data.natural_width;
            params.imageNaturalHeight = image.data.natural_height;
        }

        if (typeof image.data.editor_bbox !== 'undefined') {
            params.bbox = image.data.editor_bbox;
        }

        dimensions = this.getImageDimensionsByContainer(params);

        if (typeof image.data.editor_bbox == 'undefined') {
            this.images[imageId].data.editor_bbox = dimensions.selection.percent;
        }

        backgroundWidth = (100 / dimensions.selection.percent.width) * 100;
        backgroundHeight = (100 / dimensions.selection.percent.height) * 100;

        imageWidthCorrection = (dimensionsContainer.content.width / 100) * dimensions.selection.percent.left;
        imageHeightCorrection = (dimensionsContainer.content.height / 100) * dimensions.selection.percent.top;

        backgroundLeft = "calc("+(dimensions.selection.percent.left) + "% - "+(imageWidthCorrection)+"px)";
        backgroundTop = "calc("+dimensions.selection.percent.top + "% - "+(imageHeightCorrection)+"px)";

        image.element.find('.image-preview').css({
            'width': Math.round(dimensionsContainer.content.width), 
            'height': Math.round(dimensionsContainer.content.height),
            'background-image': 'url('+imgElement.attr('src')+')',
            'background-size': backgroundWidth+'% '+backgroundHeight+'%',
            'background-position': backgroundLeft+' '+backgroundTop
        });
    }

    setEditorOption(optionName, data) {

        if (optionName == 'aspectratio') {

            this.editorOptions.aspectratio = 'freeform';

            if (data != 'freeform') {

                data = data.split('x');

                if (data[0] != this.editorOptions.aspectratio[0] ||
                    data[1] != this.editorOptions.aspectratio[1]) {

                    data[0] = parseInt(data[0]);
                    data[1] = parseInt(data[1]);

                    this.editorOptions.aspectratio = data;
                }

            }

            let i = 0, 
                l = this.images.length;

            while (i < l) {
                if (this.editorOptions.aspectratio != 'freeform' &&
                    !this.images[i].data.editor_bbox_freeform) {

                    delete this.images[i].data.editor_bbox;
                }

                this.setEditorPreview(i);
                ++i;
            }

            this.setData();
        }
    }

    uploadEvent() {

        var self = this;

        this.element.find('.btn-upload').on('click', function() {
            self.element.find('input[name=upload]').trigger('click');
        });

        this.element.find('input[name=upload]').on('change', function() {
            self.upload($(this)[0].files);
        });
    }

    loadDataInInputs(containerElement) {

        let imageId = containerElement.find('#image_id').val(),
            image = this.images[imageId],
            i, ii, input, langCode;

        for (i = 0; i < image.data.inputs.length; ++i) {

            input = image.data.inputs[i];
            if (typeof input !== 'string') {
                input = input.name;
            }

            if (/\[LANG\]/ig.exec(input) !== null) {
               
                for (ii = 0; ii < image.data.languages.length; ++ii) {
                    langCode = image.data.languages[ii];
                    containerElement.find('#'+input.replace('[LANG]', langCode)).val(image.data[input.replace('[LANG]', langCode)]);
                }

            } else {
                containerElement.find('#'+input).val(image.data[input]);
            }
        }

        let languageTabsId = Math.random().toString(36).substr(2, 9)
        for (ii = 0; ii < image.data.languages.length; ++ii) {

            langCode = image.data.languages[ii];

            containerElement
                .find('#status_' + langCode)
                .attr('id', containerElement.find('#status_' + langCode).attr('id') + '-' + languageTabsId);

            containerElement
                .find("label[for=status_" + langCode + "]")
                .attr('for', 'status_' + langCode + '-' + languageTabsId);

            if (typeof image.data['status_' + langCode] != 'undefined') {
                let statusChecked = image.data['status_' + langCode] == 1
                    ? true
                    : false;

                containerElement.find('#status_' + langCode + '-' + languageTabsId)
                    .attr('checked', statusChecked)
                    .prop('checked', statusChecked);
            } else {
                containerElement.find('#status_' + langCode + '-' + languageTabsId)
                    .attr('checked', true)
                    .prop('checked', true);
            }
        }

        if (containerElement.find('#is_hover_' + imageId).length > 0) {

            let isHoverChecked = image.data.is_hover == '1'
                ? true
                : false;

            containerElement.find('#is_hover_' + imageId)
                .attr('checked', isHoverChecked)
                .prop('checked', isHoverChecked);
        }

        if (containerElement.find('#is_variant_image_' + imageId).length > 0) {

            let isHoverChecked = image.data.is_variant_image == '1'
                ? true
                : false;

            containerElement.find('#is_variant_image_' + imageId)
                .attr('checked', isHoverChecked)
                .prop('checked', isHoverChecked);
        }

        return containerElement;
    }

    getImageIdBySrc(src) {
        let id = false
        this.images.forEach(function(i, k) { 
            if (i.data.image_src_uploader == src) {
                id = k;
            }
        });

        return id;
    }

    getImageParams() {
        
        this.aspectRatio = '',
        this.minWidth = '',
        this.minHeight = '',
        this.maxWidth = '',
        this.maxHeight = '';

        if (typeof this.element.data('aspectratio') != 'undefined') {
            this.aspectRatio = this.element.data('aspectratio');
        }
        if (typeof this.element.data('min-width') != 'undefined') {
            this.minWidth = this.element.data('min-width');
        }
        if (typeof this.element.data('min-height') != 'undefined') {
            this.minHeight = this.element.data('min-height');
        }
        if (typeof this.element.data('max-width') != 'undefined') {
            this.maxWidth = this.element.data('max-width');
        }
        if (typeof this.element.data('max-height') != 'undefined') {
            this.maxHeight = this.element.data('max-height');
        }
    }

    upload(files) {

        var self = this, 
            i = 0,
            totalImages = files.length > (self.amountMaximal - self.images.length)
                ? (self.amountMaximal - self.images.length)
                : files.length;

        this.processingImages = totalImages;

        while (i < totalImages) {
            var formData = new FormData();
            formData.append('file', files[i]);
            formData.append('table_name', self.tableName);
            formData.append('item_id', self.itemId);
            formData.append('module', self.module);

            self.setLoading();

            $.ajax({
                url: config.domain+'/'+config.app+'/functions/module_uploader_upload.php',
                type: 'post',
                data: formData,
                contentType: false,
                processData: false,
                dataType: 'json',
                success: function(response) {
                
                    if (response.error == 0){

                        let img = new Image();
                        img.onload = function() {

                            if (typeof response.data.editor_bbox_freeform == 'undefined') {
                                response.data.editor_bbox_freeform = self.editorOptions.aspectratio_maintain_default
                                    ? false
                                    : true;
                            }

                            self.addImage(response.data);

                            self.processingImages--;

                            if (self.processingImages == 0) {
                                self.setLoading(false);
                            } 

                        }

                        img.src = response.data.image_src_uploader;
                    }
                }
            });

            ++i;
        }
    }

    setLoading(status = true) {

        this.element.find('.loading').fadeOut(function() {
            $(this).remove();
        });

        if (status) {
            this.element.append('<div class="loading"><i class="fas fa-sync-alt fa-2x fa-spin"></i><span class="sr-only">Loading...</span></div>');
        }
    }

    addImage(item) {

        if (this.amountMaximal <= this.images.length) {
            return;
        }

        let imageBlock = $(this.imageBlock.clone());

        imageBlock.find('img')
            .attr('src', item.image_src_uploader)
            .data('src', item.image_src_uploader);

        if (this.editor &&
            this.editorOptions.aspectratio == 'freeform') {
            imageBlock.find('option-aspect').addClass('d-none');
        } else {
            imageBlock.find('option-aspect').attr('data-prefix', !item.editor_bbox_freeform
                ? 'fas'
                : 'far');
        }

        this.checkWarnings($(imageBlock).find('img'));

        if (this.type == 'single') {
            imageBlock.find('.option-aspectratio').remove();
        }

        imageBlock.find('.warning').hide();

        if (item.has_star === false ||
            this.type == 'single') {
            imageBlock.find('.option-star').remove();
        } else {
           
            imageBlock = $(imageBlock[0].outerHTML.replace(
                /(option-star\sfa)(s|r)/gm, 
                `$1`+(item.star
                    ? 's'
                    : 'r')
            )); 
        }

        this.images.push({
            data: item,
            element: imageBlock
        });

        imageBlock.insertBefore(this.container.find('.block-container').eq(-1));

        if (item.has_star !== false) {
            imageBlock.find('.option-star').attr('data-prefix', item.star
                ? 'fas'
                : 'far'); 
        }

        this.checkMaximalImages();

        $('.warning').tooltip();

        if (this.editor) {
            this.setEditorPreview(this.images.length - 1);
        }

        this.setData();
    }

    checkWarnings(element) {

        // let self = this;

        // element[0].onload = function() {
    
        //     if (self.minWidth != '' || self.minHeight != '') {

        //         $.ajax({
        //             url: config.domain+'/'+config.app+'/functions/module_uploader_get_image_size.php?action=1',
        //             type: 'POST',
        //             data: {
        //                 aspect_ratio: self.aspectRatio,
        //                 min_width: self.minWidth,
        //                 min_height: self.minHeight,
        //                 max_width: self.maxWidth,
        //                 max_height: self.maxHeight,
        //                 image_width: element[0].naturalWidth,
        //                 image_height: element[0].naturalHeight                        
        //             },
        //             success: function(response) {
        //                 if (response != 'error') {
        //                     if (response == '0') {   
        //                         self.images[self.getImageIdBySrc($(element).data('src'))].element.find('.warning').show();
        //                     } else {
        //                         self.images[self.getImageIdBySrc($(element).data('src'))].element.find('.warning').hide();
        //                     }
        //                 }
        //             }
        //         });
        //     }
        // };
    }

    removeImage(imageSrc) {

        imageSrc = imageSrc.replace(/\?s=\d*/gm, "");
 
        let images = [],
            image;
        this.images.forEach(function(object, index) {

            image = typeof object.data == 'string'
                ? object.data
                : object.data.image_src_uploader;

            if (image.replace(/\?s=\d*/gm, "") != imageSrc) {
                images.push(object);
            } else {
                object.element.fadeOut(function(){
                    object.element.remove();
                });
            }
        });

        this.images = images;

        this.checkMaximalImages();

        this.setData();
    }

    checkMaximalImages() {
        if (this.amountMaximal <= this.images.length) {
            this.elementDroppable.parent().fadeOut();
        } else {
            this.elementDroppable.parent().fadeIn();
        }
    }
    
    reloadEditors() {

        console.log('reloadEditors');
        let images = [],
            i = 0,
            l = this.images.length;

        while (i < l) {
            this.setEditorPreview(i);
            ++i;
        }  
    }

    setData() {

        let images = [],
            i = 0,
            l = this.images.length;

        while (i < l) {
            images.push(this.images[i].data);
            ++i;
        }  

        this.element.find(this.inputSelector).val(JSON.stringify(images));

        this.onChange();
    }

    preventDefault() {

        this.elementDroppable.on("drop dragenter dragover", function(e) {
            e.stopPropagation();
            e.preventDefault();
        });
    }
}